import {Dispatch, SetStateAction, useState} from "react";
import {FiCheck} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {MaintenanceOccurrence} from "@/lib/types/maintenance.ts";
import {BulkEndActiveWindowsDialog} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/actions/BulkEndActiveWindowsDialog.tsx";

interface TableBulkActionsBarProps {
  occurrences: MaintenanceOccurrence[];
  selectedItems: Record<string, boolean>;
  setSelectedItems: Dispatch<SetStateAction<Record<string, boolean>>>;
}

export const TableBulkActionsBar = ({occurrences, selectedItems, setSelectedItems}: TableBulkActionsBarProps) => {
  const [showEnd, setShowEnd] = useState(false);
  const selectedOccurrences = occurrences.filter((o) => selectedItems[String(o.id)]);
  const disabled = selectedOccurrences.length === 0;

  return (
    <>
      <TableCrownButton disabled={disabled} onClick={() => setShowEnd(true)}>
        <Icon icon={FiCheck} />
        End Maintenance
      </TableCrownButton>
      <BulkEndActiveWindowsDialog
        occurrences={selectedOccurrences}
        show={showEnd}
        onClose={() => setShowEnd(false)}
        onSuccess={() => setSelectedItems({})}
      />
    </>
  );
};
